import { ModalTiteledWindow } from "./modalWindow.js";
import { DateSelect } from "../dateSelect.js";
import { RadioButtons } from "../radiobuttons.js";
import { Validator } from "../validator.js";
import { ModalConfirm } from "./modalConfirm.js";
import { MultiSelect } from "../multiSelect.js";
import {CalendarClassSelector} from "../cal-class-selector.js";

export class ModalEditAppointment extends ModalTiteledWindow {
    constructor(app, initData) {

        super();
        this.setTitle("Termin");        

        this.app = app;
        this.dm = app.dm;
        this.user = this.dm.getUserSelf();

        const defaults = {
           /*
            permission: 'teachers',
            note: '',
            */
        };

        this.initData = Object.extend(true, defaults, initData);

        this.elMain = HTMLElement.createFromHTML(`
            <div class="modal-edit-appointment">
               <div class="settings-items">
                  <div class="settings-item info">
                     <div class="sync-status"><i class="icon icon-refresh"></i><span class="icon error">!</span></div>
                     <div class="message"></div>
                  </div>

                  <div class="settings-item type">
                     <div class="outer">
                        <div class="title">Termintyp</div>
                        <div class="content">
                           <div class="validation-error-message"></div>
                           <select class="select-type"></select>
                        </div>
                     </div>
                  </div>

                  <div class="settings-item title">
                     <div class="outer">
                        <div class="title">Name des Termins</div>
                        <div class="content">
                           <div class="validation-error-message"></div>
                           <textarea rows="1" type="text" class="txt-title"></textarea>
                        </div>
                     </div>
                  </div>

                  <div class="settings-item date">
                     <div class="outer">
                        <div class="title">Datum:&nbsp;<span></span></div>
                        <div class="content">
                           <div class="validation-error-message"></div>
                        </div>
                     </div>
                  </div>

                  <div class="settings-item classes">
                     <div class="outer">
                        <div class="title">Klassen<span></span></div>
                        <div class="content">
                           <div class="validation-error-message"></div>
                           <div class="classes"></div>
                        </div>
                     </div>
                  </div>

                  <div class="settings-item owner">
                     <div class="outer">
                        <div class="title">Besitzer</div>
                        <div class="content">
                           <div class="validation-error-message"></div>
                        </div>
                     </div>
                  </div>

                  <div class="settings-item permission-view">
                     <div class="outer">
                        <div class="title">Sichtbar für den/die Besitzer und</div>
                        <div class="content">
                           <div class="validation-error-message"></div>
                        </div>
                     </div>
                  </div>

                  <div class="settings-item permission-edit">
                     <div class="outer">
                     <div class="title">Darf bearbeitet werden von dem Besitzer / den Besitzern und</div>
                        <div class="content">
                           <div class="validation-error-message"></div>
                        </div>
                     </div>
                  </div>

                  <div class="settings-item permission-delete">
                     <div class="outer">
                        <div class="title">Darf gelöscht werden von dem Besitzer / den Besitzern und</div>
                        <div class="content">
                           <div class="validation-error-message"></div>
                        </div>
                     </div>
                  </div>

                  <div class="settings-item is-public">
                     <div class="outer">
                        <div class="content">
                           <input id="cbx-appointment-public" type="checkbox" class="switch"><label for="cbx-appointment-public"></label><label for="cbx-appointment-public">Öffentlicher Termin</label>
                        </div>
                        <div>Öffentliche Termine werden (unabhängig von den sonstigen Berechtigungen) auf der Homepage veröffentlicht.</div>
                        <div   class="content-public">
                           <div class="title">Öffentliche Anmerkungen</div>            
                           <div class="txt-note-public"></div>
                        </div>
                     </div>
                  </div>

                  <div class="settings-item note">
                     <div class="outer">
                        <div class="title">Anmerkungen</div>
                        <div class="content">
                           <div class="validation-error-message"></div>
                           <div class="txt-note"></div>
                        </div>
                     </div>
                  </div>

                  <div class="settings-item note-sens">
                     <div class="outer">
                        <div class="title">Personenbezogene Anmerkungen</div>
                        <div class="content">
                           <div class="validation-error-message"></div>
                           <div class="txt-note-sens"></div>
                        </div>
                     </div>
                  </div>

               </div>
               <div class="buttons bottom-bar">
                  <i class="btn-delete icon-trash button-circle"></i>            
                  <i class="btn-save icon-check button-circle"></i>
               </div>
            </div>`
        );

      const elBtnSave = this.elMain.querySelector('.btn-save');
      const elBtnDelete = this.elMain.querySelector('.btn-delete');

      // Buttons zum Löschen und Speichern aktivieren / deaktivieren
      if (this.initData.editable || this.initData.editable === undefined) elBtnSave.onclick = () => this.save();
      else elBtnSave.classList.add('disabled');

      if (this.initData.deletable) elBtnDelete.onclick = () => this.delete();
      else elBtnDelete.classList.add('disabled');

      if (this.initData.syncStatus === 'update') {
         this.elMain.querySelector('.info .sync-status').classList.add('update');
         this.elMain.querySelector('.info .message').innerHTML = "Dieser Eintrag wurde noch nicht synchronisiert.";
      }
      else if (this.initData.syncStatus === 'error') {
         this.elMain.querySelector('.info .sync-status').classList.add('error');
         this.elMain.querySelector('.info .message').innerHTML = "Fehler beim Synchronisieren: " + this.initData.errorMessage;
      }
      else {
         this.elMain.querySelector('.info').style.display = 'none';
      }

      // Titel
      this.elTitle = this.elMain.querySelector('.settings-item.title .txt-title');

      // Checkbox
      this.elCbxPublic = this.elMain.querySelector('#cbx-appointment-public');
      this.elCbxPublic.addEventListener('change', (event) => {
         this.setPublic(event.currentTarget.checked);
      });

      const summernoteSettings = {
         /*placeholder: 'Hello stand alone ui',*/
         tabsize: 2,
         height: 120,
         toolbar: [
           ['style', ['style']],
           ['font', ['bold', 'underline', 'clear']],
           ['color', ['color']],
           ['para', ['ul', 'ol', 'paragraph']],
           ['table', ['table']],
           ['insert', ['link', 'picture', 'video']],
           ['view', ['fullscreen', 'codeview', 'help']]
         ]
       }



      this.$txtNote = $('.txt-note', this.elMain).summernote(summernoteSettings);
      this.$txtNoteSens = $('.txt-note-sens', this.elMain).summernote(summernoteSettings);
      this.$txtNotePublic = $('.txt-note-public', this.elMain).summernote(summernoteSettings);

      const userGroupIds = Object.keys(this.user.groups).map(id => parseInt(id));

      this.appTypes = this.dm.getAppointmentTypes();
      this.elSelectType = this.elMain.querySelector('.select-type');

      this.allowedAppTypes = Object.values(this.appTypes).filter(appType => Object.values(appType.permissionEdit).hasIntersectionWith(userGroupIds));

      for (const appType of this.allowedAppTypes) {
         const elOption = HTMLElement.createFromHTML('<option value="'+appType.id+'">' + appType.title + '</option>');
         this.elSelectType.appendChild(elOption);
      }

      this.elSelectType.addEventListener('change', (e) => this.onChangeAppType(e));

      // Datum
      this.dateSelect = new DateSelect({ range: true , onSelect: (from, to) => this.setDate(from, to) });
      this.elMain.querySelector('.settings-item.date .content').prepend(this.dateSelect.getElement());

      // Klassen
      this.classSelector = new CalendarClassSelector({}, this.dm);
      this.elMain.querySelector('.settings-item.classes .classes').appendChild(this.classSelector.getHtmlElement());

      // Besitzer
      this.owners = new MultiSelect({
         getItems: () => { return { list: Object.values(this.dm.getTeachers()), favList: [] }; },
         itemTextValue: (teacher) => teacher.short,
         itemSortValue: (teacher) => teacher.lastName + ', ' + teacher.firstName,
         itemId: (teacher) => teacher.id,
         listSettings: {
            columns: [
               { title: '', data: (teacher) => teacher.lastName + ' (' + teacher.short + ')' }
            ]
         }            
      });
      this.elMain.querySelector('.settings-item.owner .content').prepend(this.owners.getElement());

      // Permission-Multiselect-Einstellungen
      const permissionMultiselectSettings = {
         getItems: () => {
            const groups = Object.values(this.dm.getUserGroups());
            return {
               list: Object.values(groups),
               favList: Object.values(groups.filter(group => ['fixed', 'manual'].includes(group.type)))
            };
         },
         itemTextValue: (group) => group.name,
         itemSortValue: (group) => group.name,
         itemId: (group) => group.id,
         listSettings: {
            columns: [
               { title: '', data: (group) => group.name }
            ]
         }            
      };

      // Sichtbar für
      this.visibleFor = new MultiSelect(permissionMultiselectSettings);
      this.elMain.querySelector('.settings-item.permission-view .content').prepend(this.visibleFor.getElement());

      // Darf bearbeitet werden von
      this.editableFor = new MultiSelect(permissionMultiselectSettings);
      this.elMain.querySelector('.settings-item.permission-edit .content').prepend(this.editableFor.getElement());

      // Darf gelöscht werden von
      this.deletableFor = new MultiSelect(permissionMultiselectSettings);
      this.elMain.querySelector('.settings-item.permission-delete .content').prepend(this.deletableFor.getElement());

      // Titel
      /*
      this.elMessage = this.elMain.querySelector('.settings-item.message .txt-title');
      this.elNote = this.elMain.querySelector('.settings-item.notes .txt-note');
      this.elNoteSens = this.elMain.querySelector('.settings-item.notes .txt-note-sens');
      */

      this.loadData(this.initData);
      this.appendToBody(this.elMain);
      setTimeout(() => this.show(), 1);
   }

   onChangeAppType(e) {
      this.setAppType(this.appTypes[parseInt(e.target.value)]);
   }
   


   save() {

      const requiredClasses = this.appType.hasClasses ? 1 : 0;

      let val = new Validator([
         {
            name: 'title',
            element: this.elTitle,
            get: () => this.elTitle.value,
            validate: { 'strMinLen': 1 },
            error: { element: this.elMain.querySelector('.settings-item.title .validation-error-message'), message: "Bitte geben Sie einen Namen für diesen Termin an." }
         },
         {
            name: 'date',
            element: this.dateSelect.getElement(),
            get: () => {
               const d = this.dateSelect.getSelection();
               return this.appType.dateTo ? { from: d.from, to: d.to } : { from: d, to: d }
            },
            validate: { 'dateRange' : true },
            error: { element: this.elMain.querySelector('.settings-item.date .validation-error-message'), message: "Bitte geben Sie das Datum an." }
         },
         {
            name: 'classes',
            element: this.elMain.querySelector('.settings-item.classes'),
            get: () => this.classSelector.getSelected(),
            validate: { 'arrayMinLen': requiredClasses },
            error: { element: this.elMain.querySelector('.settings-item.classes .validation-error-message'), message: "Bitte wählen Sie mindestens eine Klasse" }
         },
         {
            name: 'owners',
            get: () => this.owners.getSelectedItemIds()
         },
         {
            name: 'permissions',
            get: () => { return {
               view: this.visibleFor.getSelectedItemIds(),
               edit: this.editableFor.getSelectedItemIds(),
               delete: this.deletableFor.getSelectedItemIds()
            }}
         },
         {
            name: 'isPublic',
            get: () => this.elCbxPublic.checked
         },
         {
            name: 'note',
            get: () => this.$txtNote.summernote('code')
         },
         {
            name: 'note-sens',
            get: () => this.$txtNoteSens.summernote('code')
         },
         {
            name: 'note-public',
            get: () => this.$txtNotePublic.summernote('code')
         },
         /*
         {
               name: 'note',
               element: this.elMessage,
               get: () => this.elMessage.value,
               validate: { 'strMinLen': 1 },
               error: { element: this.elMain.querySelector('.settings-item.message .validation-error-message'), message: "Bitte geben Sie die Nachricht an." }
               
         }
         {
               name: 'notes',
               get: () => this.elNotes.value
         },*/
      ]);

      let valiData = val.validate();

      if (valiData) {

         valiData.dateFrom = valiData.date.from.isoDate();
         valiData.dateTo   = valiData.date.to.isoDate();
         delete valiData.date;

         let data = Object.extend(true, this.initData, valiData);
         data.year = parseInt(this.year.id);
         data.type = this.appType.id;
         renameObjectKey(data, 'dateFrom', 'date-from');
         renameObjectKey(data, 'dateTo', 'date-to');

         if (!data.creator) data.creator = this.user.id;
         this.close();
         this.dm.sinRequest(Object.extend(true, data, { action: 'app-save'})).then(() => {
            this.dm.getSyncData(false, true).then(data => {
               if (data) this.dm.synchronize(data, true).then(() => this.app.cal.load(true));
            });
            this.close();
         });
      }

   }

   delete() {

      if (!this.initData.id) return;

      new ModalConfirm(
         "Soll dieser Termin wirklich gelöscht werden?",
         async (confirmed) => {
            if (confirmed) {
               await this.app.dm.sinRequest({action: 'app-delete', id: this.initData.id});
               const data = await this.app.dm.getSyncData(false, true);
               if (data) await this.app.dm.synchronize(data, true);
               this.app.cal.load(true);
               this.close();
            }
         }
      );

   }

   setAppType(appType) {
      this.elSelectType.value = appType.id;
      this.dateSelect.setOption('range', appType.dateTo);
      this.elMain.querySelector('.settings-item.classes').style.maxHeight = appType.hasClasses ? '' : '0';
      this.appType = appType;
      this.setDefaultPermissions();
   }

   setAppTitle(title) {
      this.elTitle.value = title;
   }

   setDate(from, to) {
      if (!from) {
         this.elMain.querySelector('.settings-item.date .title span').innerHTML = '';
      }
      else if (to) this.elMain.querySelector('.settings-item.date .title span').innerHTML = Date.simplifyDatePeriod(from.isoDate(), to.isoDate());
      else this.elMain.querySelector('.settings-item.date .title span').innerHTML = from.toGermanDate();
   }

   setPublic(publ) {
      this.elMain.querySelector('.content-public').style.maxHeight = publ ? '500px' : 0;
   }

   setDefaultPermissions() {
      this.visibleFor.setSelection  (this.appType.defaults.view   ? Object.values(this.appType.defaults.view)   : []);
      this.editableFor.setSelection (this.appType.defaults.edit   ? Object.values(this.appType.defaults.edit)   : []);
      this.deletableFor.setSelection(this.appType.defaults.delete ? Object.values(this.appType.defaults.delete) : []);      
   }

   getClassList() {
      let classes = Object.values(this.dm.getClasses());

      return {
         list:    classes.filter(cls => !cls.teachers.find(t => t.id === this.user.id)),
         favList: classes.filter(cls => cls.teachers.find(t => t.id === this.user.id)),
      };
   }

   async loadData(data) {

      this.setAppType(data.typeId && this.appTypes.hasOwnProperty(data.typeId) ? this.appTypes[data.typeId] : this.allowedAppTypes[Object.keys(this.allowedAppTypes)[0]]);
      this.setAppTitle(data.title ? data.title : '');

      this.dateSelect.select(data.dateFrom ? new Date(Date.fromString(data.dateFrom)) : false, data.dateTo ? new Date(Date.fromString(data.dateTo)) : false);

      this.year = this.dm.getCurrentYear();
      this.classSelector.setClasses(this.year.classes, Object.values(data.classes || {}));

      this.owners.setSelection(Object.values(data.owners || { id: this.user.id }));

      if (data.permissionGroups) {
         this.visibleFor.setSelection  (data.permissionGroups.view   ? Object.values(data.permissionGroups.view)   : []);
         this.editableFor.setSelection (data.permissionGroups.edit   ? Object.values(data.permissionGroups.edit)   : []);
         this.deletableFor.setSelection(data.permissionGroups.delete ? Object.values(data.permissionGroups.delete) : []);
      }
      else {
         this.setDefaultPermissions();
      }

      this.elCbxPublic.checked = data.isPublic;
      this.setPublic(data.isPublic);

      const note = await this.getNote(data, 'note');
      const noteSens = await this.getNote(data, 'noteSens');
      const notePublic = await this.getNote(data, 'notePublic');

      this.$txtNote.summernote('code', note || '');
      this.$txtNoteSens.summernote('code', noteSens || '');
      this.$txtNotePublic.summernote('code', notePublic || '');
      
   }

   async getNote(app, noteName) {
      if (app[noteName] === false) {
         if (this.app.dm.online) {
            app = await this.reloadAppointment(app);
            return app[noteName];
         }
         else {
            return "[ Diese Information kann nur angezeigt werden, wenn eine Internetverbindung besteht. ]";
         }
      }
      else {
         return app[noteName];
      }
   }

   async reloadAppointment(app) {
      const resp = await this.app.dm.sinRequest({action: 'app-get-by-id', 'appId': app.id});

      if (resp.data) return resp.data;
      else {
         toast.alert("Der Termin mit der ID " + app.id + " konnte nicht geladen werden.", { duration: 8000 });
         logger.error("Der Termin mit der ID " + app.id + " konnte nicht geladen werden.");
         return app;
      }
   }


}

